import React, { useContext } from 'react';
import { ETables } from '../../types/enums/ETables';
import TableWithState from '../../components/TableWithState/TableWithState';
import useColumnsHeaders from '../../utils/useColumnsHeaders';
import { NSSystemUsers } from '../../types/interfaces/NSSystemUsers';
import useCellStatusStyleHandler from '../../utils/useCellStatusStyleHandler';
import { SessionContext } from '../../contexts/session/SessionContext';
import RemoveCircleIcon from '@material-ui/icons/RemoveCircle';

const SystemUsers = () => {
  const cellStyleHandler = useCellStatusStyleHandler();
  const { permissions } = useContext(SessionContext);

  const dataFormatter = (dataTable: NSSystemUsers.ITableItem[]): NSSystemUsers.IFormattedItem[] =>
    dataTable.map((table) => ({
      email: table.email,
      _id: table._id,
      nameSurname: table.nameSurname,
      status: table.status.current,
      delete: <RemoveCircleIcon style={{ marginLeft: 10, color: 'red', cursor: 'pointer' }} />,
    }));

  const columns = useColumnsHeaders([
    { accessorAsHeader: 'status' },
    { accessorAsHeader: 'nameSurname' },
    { accessorAsHeader: 'email' },
    { accessorAsHeader: 'delete' },
  ]);

  return (
    <TableWithState
      tableName={ETables.SystemUsers}
      dataFormatter={dataFormatter}
      cellStyleHandler={cellStyleHandler}
      columns={columns}
      exportable={true}
      addable={permissions.systemUsers.edit}
    />
  );
};

export default SystemUsers;
